import { instance } from '@/utils/http.js'

// 整卷测试获取模板
export const getTemplate = (params) => {
  return instance({
    url: '/api/v1/cp/cp_subject_tmp',
    method: 'get',
    params
  })
}